/**
 * Cart Redesign — Free shipping progress bar
 * Reads threshold from data attribute set by Liquid.
 */
(function () {
  function initShippingBar() {
    const bar = document.querySelector('[data-cs-shipping-bar]');
    if (!bar) return;

    const threshold = parseInt(bar.dataset.threshold, 10); // in cents
    if (!threshold) return;

    const fill  = bar.querySelector('[data-cs-fill]');
    const label = bar.querySelector('[data-cs-label]');

    function update(totalCents) {
      const pct      = Math.min((totalCents / threshold) * 100, 100);
      const remaining = Math.max(threshold - totalCents, 0);
      const currency  = window.Shopify?.currency?.active || 'CLP';
      const locale    = document.documentElement.lang || 'es-CL';
      const fmt       = (c) => new Intl.NumberFormat(locale, { style: 'currency', currency }).format(c / 100);

      if (fill)  fill.style.width = pct + '%';

      if (label) {
        if (remaining === 0) {
          label.innerHTML = '🎉 <strong>¡Tienes envío gratis!</strong>';
        } else {
          label.innerHTML = `Agrega <strong>${fmt(remaining)}</strong> más para obtener <strong>envío gratis</strong>`;
        }
      }
    }

    // Initial render
    const initialTotal = parseInt(bar.dataset.cartTotal, 10) || 0;
    update(initialTotal);

    // Update when cart changes (subscribe to Dawn's pub/sub)
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        const total = event.cartData?.total_price ?? 0;
        update(total);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShippingBar);
  } else {
    initShippingBar();
  }
})();
